module.exports = __webpack_public_path__ + "img/renaissance_cleaning_services_13.09b6a774.jpg";